import React,{ useEffect, useState } from 'react';
import { history, useLocation } from 'umi';
// import router from 'umi/router';
import './index.less';
import { getUserInfo,getUserLevel,getCoursePrivilege } from '@/services/myself';
import { Toast } from 'antd-mobile';
import { setLoginUser,getLoginUser } from '@/utils/login';
import memberFlag from '@/assets/vip_flag.png';
import { Dialog, Page } from 'react-weui';


export default () => {
  const [user, setUser] = useState({});
  const [level, setLevel] = useState(null);

  const [vipData, setVipData] = useState(null);
  const [isMemberShow, setIsMemberShow] = useState(false);
  const [checkMemberShow, setCheckMemberShow] = useState(false);

  useEffect(() => {

    Toast.loading('loading',60);
    getUserInfo().then(res => {
      // console.log(res);
      Toast.hide();
      if (res && res.code == 200) {
        setUser(res.data);
        setLoginUser(res.data);
      }else {
        Toast.fail('获取失败，请重试');
      }
    }).catch(e=>{
      Toast.hide();
      Toast.fail('获取失败，请重试');
    });


    getUserLevel().then(res => {
      if (res && res.code == 200) {
        setLevel(res.data);
      }
    });

    getCoursePrivilege().then(res=>{
      if (res && res.code == 200) {
        setVipData(res.data);
      }
    });
  }, []);

  // 个人中心按钮内容数组
  const personalCenterItems = [
    {
      icon: require('@/assets/course_record.png'),
      label: '课程历史',
      onClick: () => history.push({pathname:'/myself/courseList',state:{type:1}})
    },
    {
      icon: require('@/assets/course_buyed.png'),
      label: '兑换历史',
      onClick: () => history.push({pathname:'/myself/courseList',state:{type:2}})
    },
    {
      icon: require('@/assets/collect.png'),
      label: '我的收藏',
      onClick: () => history.push({pathname:'/myself/collectList',state:{}})
    },
    {
      icon: require('@/assets/learn_point.png'),
      label: '我的积分',
      onClick: () => history.push({pathname:'/myself/myPoint',state:{user:user}})
    },
    {
      icon: require('@/assets/point.png'),
      label: '我的果实',
      onClick: () => history.push({pathname:'/myself/myFiruit',state:{user:user}})
    },
    {
      icon: require('@/assets/sign.png'),
      label: '浏览记录',
      onClick: () => history.push({pathname:'/myself/browseList',state:{}})
    },
    {
      icon: require('@/assets/message.png'),
      label: '回复我的',
      onClick: () => history.push({pathname:'/myself/replyMe',state:{}})
    },
    {
      icon: require('@/assets/good.png'),
      label: '收到的赞',
      onClick: () => history.push({pathname:'/myself/likeMe',state:{}})
    },
    {
      icon: require('@/assets/notify.png'),
      label: '系统通知',
      onClick: () => history.push({pathname:'/myself/message',state:{}})
    },
    {
      icon: require('@/assets/points_list.png'),
      label: '积分榜',
      onClick: () => {
        if (user && user.commonid) {
          history.push({ pathname: '/myself/ranking', state: {} });
        } else {
          setCheckMemberShow(true);
        }
      }
    },
  ];

  // 会员中心按钮内容数组
  const memberCenterItems = [
    {
      icon: require('@/assets/open.png'),
      label: '开通会员',
      onClick: () => {
        if (user && user.commonid) {
          setIsMemberShow(true);
        } else {
          history.push({ pathname: '/myself/member', state: {} });
        }
      }
    }
  ];


  return (
    <div className='box'>
      <div className='header'>
        <img alt={""} className='header-img' src={user.avatarurl}/>
        <div className='header-content'>
          <label className='header-content-name'>
            {user.nickname} &nbsp;
            { user.commonid ? <img style={{width: '24px', height: '24px', marginTop: '-5px'}} src={memberFlag} /> : null }
          </label>

          {level && <label className='header-content-label'>{level.name}</label>}

          <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
            <label className='header-content-score'>果实：{user.fruit}</label>
            <label className='header-content-score' style={{marginLeft:'15px'}}>积分：{user.power}</label>
          </div>

          {vipData &&
          <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'10px'}}>
            <img alt={""} className='header-vip-img' src={require('@/assets/vip.png')}/>
            <label className='header-vip-text'>幸福课堂有效期：{vipData.validityDate}</label>
          </div>}
        </div>
      </div>

      {/* 个人中心 */}
      {personalCenterItems.length > 0 && (
        <div className='button-box'>
          <label className='button-box-title'>个人中心</label>
          <div className='button-box-grid'>
            {personalCenterItems.map((item, idx) => (
              <div className='button-item' key={idx} onClick={item.onClick}>
                <img alt='' className='button-item-img' src={item.icon}/>
                <label className='button-item-name'>{item.label}</label>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* 会员中心 */}
      {memberCenterItems.length > 0 && (
        <div className='button-box'>
          <label className='button-box-title'>会员中心</label>
          <div className='button-box-grid'>
            {memberCenterItems.map((item, idx) => (
              <div className='button-item' key={idx} onClick={item.onClick}>
                <img alt='' className='button-item-img' src={item.icon}/>
                <label className='button-item-name'>{item.label}</label>
              </div>
            ))}
          </div>
        </div>
      )}

      <div style={{'height':'20px'}}/>

      <Dialog type="ios" title={'提示信息'} buttons={[{
        label: '确定',
        onClick: () => setIsMemberShow(false),
      }]} show={isMemberShow}>
        您已经是会员了，无需再次开通会员。
      </Dialog>

      <Dialog type="ios" title={'提示信息'} buttons={[{
        label: '确定',
        onClick: () => {
          setCheckMemberShow(false);
          history.push({ pathname: '/myself/member', state: {} });
        },
      }]} show={checkMemberShow}>
        需要先开通会员，才可以使用此功能。
      </Dialog>

    </div>
  );


}
